<template>
    <div class="gs-affiliate-retry-history">
        <div v-if="selectedTransaction.transaction_retry_logs.length > 0" id="retries-list-view"
            class="flex flex-row w-full">
            <v-client-table :data="selectedTransaction.transaction_retry_logs" :columns="failedLogsColumns"
                :options="failedLogsTableOptions">
                <div slot="log" slot-scope="props">
                    <div v-if="props.row.description ==
                        'auto_retry_attempt_successful'" class="flex flex-row">
                        {{ $t('frontend_affiliate_transactions_automatic_dunning') }}
                    </div>
                    <div v-else-if="props.row.description == 'auto_retry_attempt_failed'" class="flex flex-row">
                        {{ $t('frontend_affiliate_transactions_automatic_dunning_retry') }}
                    </div>
                    <div v-else-if="props.row.description == 'manual_retry_attempt_successful'" class="flex flex-row">
                        {{
                            $t('frontend_affiliate_transactions_manual_dunning')
                        }}
                    </div>
                    <div v-else-if="props.row.description == 'manual_retry_attempt_failed'" class="flex flex-row">
                        {{ $t('frontend_affiliate_transactions_manual_dunning_retry') }}
                    </div>
                    <div v-else class="flex flex-row">
                        {{ $t('frontend_affiliate_transactions_initial_fail') }}
                    </div>
                </div>
                <div slot="date" slot-scope="props">
                    <div class="flex flex-row">
                        {{ props.row.created_at_date }} -
                        {{ props.row.created_at_time }}
                    </div>
                </div>
            </v-client-table>
        </div>
        <div v-else class="flex flex-row w-full gs-affiliate-retry-empty" role="status">
            {{
                $t('frontend_affiliate_transactions_no_dunning_attempts')
            }}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        selectedTransaction: {
            type: Object,
            default: () => { }
        },
    },
    data() {
        return {
            failedLogsColumns: ['log', 'date'],
            failedLogsTableOptions: {
                headings: {
                    log: this.$t('frontend_activity_log'),
                    date: this.$t('frontend_affiliate_index_formatted_date_time'),
                },
                perPage: 5,
                texts: {
                    filterPlaceholder: this.$t('frontend_analytics_transactions_search'),
                    filter: '',
                },
            },


        }
    },
}
</script>

<style scoped>
.gs-affiliate-retry-history {
    min-width: 0;
    max-width: 100%;
    color: var(--gs-foreground);
}
.gs-affiliate-retry-history ::v-deep .VueTables__table {
    border: 1px solid var(--gs-border);
    border-collapse: collapse;
}
.gs-affiliate-retry-history ::v-deep #retries-list-view .VueTables__heading {
    color: var(--gs-muted-foreground);
}
.gs-affiliate-retry-history ::v-deep .VueTables__table th {
    background: var(--gs-surface-subtle);
}
.gs-affiliate-retry-history ::v-deep .VueTables__table th,
.gs-affiliate-retry-history ::v-deep .VueTables__table td {
    border-color: var(--gs-border);
    vertical-align: top;
    line-height: 1.5;
}
.gs-affiliate-retry-history ::v-deep .VueTables__table td:last-child {
    font-variant-numeric: tabular-nums;
}
.gs-affiliate-retry-history ::v-deep #retries-list-view .VuePagination__pagination {
    flex-wrap: wrap;
    margin: 12px 0;
    padding: 0;
    gap: 0;
}
.gs-affiliate-retry-history ::v-deep #retries-list-view .VuePagination__pagination-item {
    padding: 0;
}
.gs-affiliate-retry-history ::v-deep .VuePagination__pagination a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    min-height: 44px;
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-sm);
    color: var(--gs-foreground);
    background: var(--gs-surface);
}
.gs-affiliate-retry-history ::v-deep .VuePagination__pagination .active a {
    color: var(--gs-primary-foreground);
    background: var(--gs-primary);
    border-color: var(--gs-primary);
}
.gs-affiliate-retry-history ::v-deep .VuePagination__pagination a:focus-visible {
    outline: 2px solid var(--gs-ring);
    outline-offset: 2px;
}
@media (max-width: 340px) {
    .gs-affiliate-retry-history ::v-deep #retries-list-view .VuePagination__pagination {
        display: grid;
        grid-template-columns: repeat(3, minmax(44px, 1fr));
        gap: 4px;
    }
    .gs-affiliate-retry-history ::v-deep .VuePagination__pagination a {
        width: 100%;
    }
}
.gs-affiliate-retry-empty {
    padding: 20px 0;
    line-height: 1.5;
    color: var(--gs-muted-foreground);
}
</style>
